/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confidential_DocumentsInputs */

const en_confidential_documents = /** @type {(inputs: Confidential_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confidential Documents`)
};

const id_confidential_documents = /** @type {(inputs: Confidential_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumen Rahasia`)
};

/** @type {(inputs: Confidential_DocumentsInputs) => LocalizedString} */
const es_confidential_documents = en_confidential_documents;

/** @type {(inputs: Confidential_DocumentsInputs) => LocalizedString} */
const fr_confidential_documents = en_confidential_documents;

/** @type {(inputs: Confidential_DocumentsInputs) => LocalizedString} */
const de_confidential_documents = en_confidential_documents;

/** @type {(inputs: Confidential_DocumentsInputs) => LocalizedString} */
const ja_confidential_documents = en_confidential_documents;

/** @type {(inputs: Confidential_DocumentsInputs) => LocalizedString} */
const zh_confidential_documents = en_confidential_documents;

/** @type {(inputs: Confidential_DocumentsInputs) => LocalizedString} */
const ar_confidential_documents = en_confidential_documents;

/** @type {(inputs: Confidential_DocumentsInputs) => LocalizedString} */
const it_confidential_documents = en_confidential_documents;

/** @type {(inputs: Confidential_DocumentsInputs) => LocalizedString} */
const ru_confidential_documents = en_confidential_documents;

/** @type {(inputs: Confidential_DocumentsInputs) => LocalizedString} */
const pt_confidential_documents = en_confidential_documents;

/** @type {(inputs: Confidential_DocumentsInputs) => LocalizedString} */
const ko_confidential_documents = en_confidential_documents;

/**
* | output |
* | --- |
* | "Confidential Documents" |
*
* @param {Confidential_DocumentsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const confidential_documents = /** @type {((inputs?: Confidential_DocumentsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confidential_DocumentsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_confidential_documents(inputs)
	if (locale === "es") return es_confidential_documents(inputs)
	if (locale === "fr") return fr_confidential_documents(inputs)
	if (locale === "de") return de_confidential_documents(inputs)
	if (locale === "ja") return ja_confidential_documents(inputs)
	if (locale === "zh") return zh_confidential_documents(inputs)
	if (locale === "ar") return ar_confidential_documents(inputs)
	if (locale === "id") return id_confidential_documents(inputs)
	if (locale === "it") return it_confidential_documents(inputs)
	if (locale === "ru") return ru_confidential_documents(inputs)
	if (locale === "pt") return pt_confidential_documents(inputs)
	return ko_confidential_documents(inputs)
});